import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { State } from '../models/state.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class StateService {
  private baseUrl: string; // = "https://localhost:44353/api/officesetup";
  private api: string = "api/State";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('State Service Client Side Error: ', errorResponse.error.message);
    } else {
      console.error('State Service Server Side Error: ', errorResponse);
    }

    return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
  }

  async getStateList(encryptedUser: string): Promise<State[] | void> {
    const a = this.httpClient
      .get<State[]>(this.baseUrl, {
        headers: new HttpHeaders({
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "StateService", "getStateList"); });

    return a;
  }
}
